import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { environment } from 'src/environments/environment';
import { toODataString, toDataSourceRequestString, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ListAssetByAccountNoService extends BehaviorSubject < GridDataResult > {
  public loading: boolean;
  public tableName: string;
  public param1: string;
  public param2: string;
  public param3: string;
  public param4: string;
  public param5: string;
  private BASE_URL = environment.apiUrl;
  refreshTrigger = new Subject<string>();
  importStarted = new Subject<string>();
  constructor(private http: HttpClient) {
    super(null);
  }
  refreshTable(gridName: string, param1: string = '', param2: string = '', param3: string = '', param4: string = '', param5: string = '') {
    if (param1 !== '') {
      this.param1 = param1;
    }
    if (param2 !== '') {
      this.param2 = param2;
    }
    if (param3 !== '') {
      this.param3 = param3;
    }
    if (param4 !== '') {
      this.param4 = param4;
    }
    if (param5 !== '') {
      this.param5 = param5;
    }
    this.refreshTrigger.next(gridName);
  }
  importTable(gridName: string) {
    this.importStarted.next(gridName);
  }
  public query(state: any): void {
    this.fetch(this.tableName, this.param1, this.param2, this.param3, this.param4, this.param5, state).subscribe((x) => super.next(x));
  }


  protected fetch(tableName: string, param1: string, param2: string, param3: string, param4: string, param5: string, state: any): Observable<GridDataResult> {
    const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
    const hasGroups = state.group && state.group.length;
    this.loading = true;
    let url = `${this.BASE_URL}${tableName}?${queryStr}`;
    url = `${this.BASE_URL}${tableName}/${param1}/${param2}?${queryStr}`;


    return this.http.get(url).pipe(
      map(
        (
          { data, total /*, aggregateResults*/ }: GridDataResult // Process the response
        ) =>
          <GridDataResult>{
            // If there are groups, convert them to a compatible format
            data: hasGroups ? translateDataSourceResultGroups(data) : data,
            total: total
          }
      ),
      tap(() => (this.loading = false))
    );
  }
}